import React, { useState, useEffect } from 'react'
import SideBar from "../../components/ThirdPartyDashboard/SideBar";
import Search from "../../components/ThirdPartyDashboard/Search";
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { facilityVerify, SubmitComment, ListComment } from "../../apis/General/web3/shared";
import "../../styles/ThirdParty/Verification.scss";
import { useSelector } from 'react-redux';
import { getThreeMonthUnverifiedAccumulationsForPlant, getIndividualEmissionsForCard } from "../../instantiateTransaction/basicInfrastructureChange";
import { toast } from 'react-toastify';

function NonGreenWeb3Data() {
    const { id } = useParams();
    const [plantData, setPlantData] = useState(null);
    const [unverifiedData, setUnverifiedData] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [pageSize, setPageSize] = useState(50);
    const [currentPage, setCurrentPage] = useState(1);
    const [openCommentModal, setOpenCommentModal] = useState(false);
    const [openVerifyModal, setOpenVerifyModal] = useState(false);
    const [isClosing, setIsClosing] = useState(false);
    const [comment, setComment] = useState('');
    const [verificationLoading, setVerificationLoading] = useState(false);

    const recordsPerPage = 8;
    const plantAddress = id;
    const createdAt = "1756893278085"
    const sensorId = "NGF-IFC-DSL-4625556"
    const auth = useSelector((state) => state.auth);

    const {rangeStartDate} = useParams()
    const {rangeEndDate} = useParams()
     const {totalEd} = useParams()
        const {baseline} = useParams()
    // const {id} = useParams()
    // Modal handlers
    const handleCloseCommentModal = () => {
        setIsClosing(true);
        setTimeout(() => {
            setOpenCommentModal(false);
            setIsClosing(false);
        }, 300);
    };

    const handleCloseVerifyModal = () => {
        setIsClosing(true);
        setTimeout(() => {
            setOpenVerifyModal(false);
            setIsClosing(false);
        }, 300);
    };

    const handleCommentSubmit = async () => {
        // Handle comment submission logic here
        try {
            console.log('Comment submitted:', comment);
            const userId = "UN9ujbCjkMHfmgKWhM38maR4";
            const submitComment = await SubmitComment(comment, userId, auth?.token);
            console.log("Comment Submission Response:", submitComment);
            setComment('');
            setOpenCommentModal(false);
            toast.success("Comment submitted successfully!");
        } catch (err) {
            console.error("Error submitting comment:", err);
            toast.error("Failed to submit comment. Please try again.");
        }
    };

    const handleVerifyConfirm = async () => {
        try {
            setVerificationLoading(true);
            await facilityVerify(
                plantAddress,
                "infrastructure-change",
                "basic",
                auth?.token
            );
            toast.success("Facility verified successfully!");
            setOpenVerifyModal(false);
            // Refresh data after verification
            fetchAllUnverifiedAccumulations();
            if (id) {
                getThreeMonthUnverifiedAccumulationsForPlantData(id);
            }
        } catch (err) {
            console.error("Error verifying facility:", err);
            alert("Failed to verify facility. Please try again.");
        } finally {
            setVerificationLoading(false);
        }
    };

    const getThreeMonthUnverifiedAccumulationsForPlantData = async (address) => {
        try {
            setLoading(true);
            setError(null);
            const result = await getThreeMonthUnverifiedAccumulationsForPlant(address);
            console.log("Three Month Unverified Accumulations for Plant:", result);
            setPlantData(result);
        } catch (err) {
            console.error("Error fetching data for plant:", err);
            setError(err.message || "Failed to fetch plant data");
        } finally {
            setLoading(false);
        }
    }

  
      const fetchAllUnverifiedAccumulations = async () => {
          try {
              setLoading(true);
              setError(null);
              
              const result = await getIndividualEmissionsForCard(id, rangeStartDate, rangeEndDate);
              console.log("All Unverified Data:", result);
            //   setWalletAddress(result?.plantAddress || id);
              
              setUnverifiedData(result);
          } catch (err) {
              console.error("Error fetching all unverified accumulations:", err);
              setError(err.message || "Failed to fetch unverified data");
          } finally {
              setLoading(false);
          }
      };
  

    // Transform the console data into table rows
    const transformDataToTableRows = () => {
        const rows = [];
        
        if (unverifiedData?.individualEmissions && Array.isArray(unverifiedData.individualEmissions)) {
            unverifiedData.individualEmissions.forEach((emission, index) => {
                // Create table row data from individual emission
                const rowData = {
                    id: index + 1,
                    date: emission.date || 'N/A',
                    projectEmission: `${emission.totalGHGEmissions || '0.00'}tCO2e`,
                    baselineEmission: `${emission.quantifiedGHGEmissionsInBaselineScenario || '0.00'}tCO2e`,
                    energyConsumption: `${emission.directStationaryEmissionsValue || '0.00'}tCO2e`,
                    emissionReduction: calculateEmissionReduction(emission),
                    plantAddress: unverifiedData.plantAddress,
                    facilityName: plantData?.facilityName || 'Unknown Facility'
                };
                
                rows.push(rowData);
            });
        }
        
        return rows;
    };

    // Calculate emission reduction
    const calculateEmissionReduction = (emission) => {
        const baseline = parseFloat(emission.quantifiedGHGEmissionsInBaselineScenario) || 0;
        const project = parseFloat(emission.totalGHGEmissions) || 0;
        
        if (baseline > project) {
            return `${(baseline - project).toFixed(4)}tCO2`;
        }
        return '0.0000tCO2';
    };

    // Pagination logic
    const allRows = transformDataToTableRows();
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = allRows.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(allRows.length / recordsPerPage);

    const handlePreviousPage = () => {
        setCurrentPage(prev => Math.max(prev - 1, 1));
    };

    const handleNextPage = () => {
        setCurrentPage(prev => Math.min(prev + 1, totalPages));
    };

    const handleRefresh = () => {
        fetchAllUnverifiedAccumulations();
        if (id) {
            getThreeMonthUnverifiedAccumulationsForPlantData(id);
        }
    };

    useEffect(() => {
        fetchAllUnverifiedAccumulations();
        if (id) {
            getThreeMonthUnverifiedAccumulationsForPlantData(id);
        } else {
            setError("No plant address provided");
            setLoading(false);
        }
    }, [id]);

    return (
        <div className="thirdparty_verification">
            <div className="sidebar_container">  
                <SideBar />
            </div>

            <div className="main">
                <Search />
                
                {loading && (
                    <div className="flex justify-center items-center py-8">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#006633]"></div>
                        <span className="ml-2 text-gray-600">Loading plant data...</span>
                    </div>
                )}

                {error && (
                    <div className="border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                        Error: {error}
                    </div>
                )}

                {plantData && !loading && (
                    <div className="flex flex-col items-end p-0 gap-4 w-full max-w-[1155px] mx-auto">
                        {/* Action Buttons */} 
                        <div className="flex flex-row justify-end items-start p-0 gap-5 w-[333px] h-[59px]">
                            {/* Leave Comment Button */}
                            <button 
                                className="flex flex-row justify-center items-center p-2 gap-2 w-[167px] h-[59px] box-border border border-[#006633] rounded-lg hover:bg-gray-50 transition-colors"
                                onClick={() => setOpenCommentModal(true)}
                            >
                                <span className="w-[135px] h-6 font-inter font-semibold text-[16px] leading-6 text-center bg-gradient-to-r from-[#006633] to-[#00AED9] bg-clip-text text-transparent">
                                    Leave Comment
                                </span>
                            </button>

                            {/* Verify Button */}
                            <button 
                                className="flex flex-row justify-center items-center p-2 gap-3 w-[154px] h-[59px] bg-gradient-to-r from-[#038B47] to-[#00AED9] rounded-lg hover:opacity-90 transition-opacity"
                                onClick={() => setOpenVerifyModal(true)}
                            >
                                <span className="w-[46px] h-6 font-inter font-semibold text-[16px] leading-6 text-white">
                                    Verify
                                </span>
                            </button>
                        </div>

                        {/* Plant Information Card */}
                       <div className=" mr-72">
      {/* Responsive grid: 1 column on mobile, 3 columns on desktop */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Column 1: Organization & Date Info */}
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <span className="min-w-[140px] text-[14px] font-normal text-gray-800">
              Organizational Name:
            </span>
            <span className="font-medium text-[14px] text-gray-800">
              {plantData.facilityName || 'Mainstream'}
            </span>
          </div>
          <div className="flex items-start gap-3">
            <span className="min-w-[140px] text-[14px] font-normal text-gray-800">
              Reporting period:
            </span>
            <span className="font-medium text-[14px] text-gray-800">
              {plantData.reportingPeriod || 'Quarterly'}
            </span>
          </div>
          <div className="flex items-start gap-3">
            <span className="min-w-[140px] text-[14px] font-normal text-gray-800">
              Date:
            </span>
            <span className="font-medium text-[14px] text-gray-800">
              {unverifiedData.rangeStartDate || 'no date'} - {unverifiedData.rangeEndDate || 'date'}
            </span>
          </div>
        </div>

        {/* Column 2: Emission Data */}
<div className="w-[400px]"> {/* Fixed width container */}
  {/* Row 1: Total Project emission */}
  <div className="flex items-start gap-4 py-2">
    <span className="w-[200px] text-[14px] font-normal text-gray-800">
      Total Project emission data:
    </span>
    <span className="w-[180px] text-[16px] text-[#101828]">
      {totalEd || '0.00'} tCO2e
    </span>
  </div>

  {/* Row 2: Total Baseline emission */}
  <div className="flex items-start gap-4 py-2">
    <span className="w-[200px] text-[14px] font-normal text-gray-800">
      Total Baseline emission data:
    </span>
    <span className="w-[180px] text-[16px] text-[#101828]">
      {baseline || '0.00'} tCO2e
    </span>
  </div>

  {/* Row 3: Direct stationary emissions */}
  <div className="flex items-start gap-4 py-2">
    <span className="w-[200px] text-[14px] font-normal text-gray-800">
      Total Direct stationary emissions:
    </span>
    <span className="w-[180px] font-medium text-[14px] text-gray-800">
      {plantData.energyConsumptionInKWh || '0.00'} tCO2e
    </span>
  </div>

  {/* Row 4: Facility capacity */}
  <div className="flex items-start gap-4 py-2">
    <span className="w-[200px] text-[14px] font-normal text-gray-800">
      Facility capacity:
    </span>
    <span className="w-[180px] font-medium text-[14px] text-gray-800">
      {plantData.facilityCapacity || '0.00'} MW
    </span>
  </div>
</div>
        {/* Column 3: Document Links */}
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <span className="text-[14px] font-normal text-gray-800">
              Energy consumption data:
            </span>
            <Link
              to={`/iot/${sensorId}/${createdAt}`}
              className="text-[14px] font-semibold text-green-600 underline hover:opacity-80"
            >
              View
            </Link>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-[14px] font-normal text-gray-800">KYC:</span>
            <Link
              to={`/kcy/verifier/${plantAddress}`}
              className="text-[14px] font-semibold text-green-600 underline hover:opacity-80"
            >
              View
            </Link>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-[14px] font-normal text-gray-800">        
              Quantification methodology:
            </span>
            <button className="text-[14px] font-semibold text-green-600 underline hover:opacity-80">
              View
            </button>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-[14px] font-normal text-gray-800">    
              Project design document:
            </span>
            <button className="text-[14px] font-semibold text-green-600 underline hover:opacity-80">
              View
            </button>
          </div>
        </div>
      </div>
    </div>

                        {/* Emission Data Table */}
                        <div className="w-full mt-8">
                            {!loading && !error && allRows.length === 0 && (
                                <div className="text-center py-8 bg-gray-50 rounded-lg">
                                    <p className="text-gray-500 text-lg">No unverified plants found</p>
                                    <p className="text-gray-400 text-sm mt-2">All plants might be verified or there are no plants in the contracts</p>
                                </div>
                            )}

                            {!loading && !error && allRows.length > 0 && (
                                <div className="box-border w-full h-[582px] border border-[#E5E5E5] rounded-2xl">
                                    <div className="flex flex-col items-start p-0 w-full h-[582px]">
                                        {/* Table Header */}
                                        <div className="flex flex-col justify-center items-center p-0 w-full h-[52px] bg-[#2C9963] rounded-t-2xl">
                                            <div className="flex flex-row justify-center items-center p-0 w-full h-[48px]">
                                                {/* Date Column */}
                                                <div className="flex flex-row justify-center items-center pr-2.5 w-[130px] h-[48px]">
                                                    <div className="flex flex-row justify-center items-center p-2 gap-1.5 w-[52px] h-8 rounded-lg">
                                                        <span className="w-[32px] h-[18px] font-inter font-normal text-[14px] leading-[18px] text-white">
                                                            Date
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Project Emission Column */}
                                                <div className="flex flex-row justify-center items-center pr-2.5 w-[205px] h-[48px]">
                                                    <div className="flex flex-row justify-center items-center p-2 gap-1.5 w-[163px] h-8 rounded-lg">
                                                        <span className="w-[143px] h-[18px] font-inter font-normal text-[14px] leading-[18px] text-white">
                                                            Project emission data
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Baseline Emission Column */}
                                                <div className="flex flex-row justify-center items-center pr-2.5 w-[241px] h-[48px]">
                                                    <div className="flex flex-row justify-center items-center p-2 gap-1.5 w-[172px] h-8 rounded-lg">
                                                        <span className="w-[152px] h-[18px] font-inter font-normal text-[14px] leading-[18px] text-white">
                                                            Baseline emission data
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Direct Stationary Emissions Column */}
                                                <div className="flex flex-row justify-center items-center pr-2.5 w-[243px] h-[48px]">
                                                    <div className="flex flex-row justify-center items-center p-2 gap-1.5 w-[192px] h-8 rounded-lg">
                                                        <span className="w-[172px] h-[18px] font-inter font-normal text-[14px] leading-[18px] text-white">
                                                            Direct stationary emissions
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Emission Reduction Column */}
                                                <div className="flex flex-row justify-center items-center pr-2.5 w-[210px] h-[48px]">
                                                    <div className="flex flex-row justify-center items-center p-2 gap-1.5 w-[179px] h-8 rounded-lg">
                                                        <span className="w-[159px] h-[18px] font-inter font-normal text-[14px] leading-[18px] text-white">
                                                            Emission reduction data
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Table Body */}
                                        <div className="flex flex-col items-start p-0 w-full h-[424px] overflow-y-auto">
                                            {currentRecords.map((record, index) => (
                                                <div key={record.id} className="flex flex-col justify-center items-center p-0 w-full h-[52px] bg-white border-b border-[#E5E5E5]">
                                                    <div className="flex flex-row justify-center items-center p-0 w-full h-[48px]">
                                                        {/* Date */}
                                                        <div className="flex flex-row justify-center items-center pr-2.5 w-[130px] h-[48px]">
                                                            <div className="flex flex-row justify-center items-center p-2 gap-1.5 w-[101px] h-8 rounded-lg">
                                                                <span className="w-[81px] h-[18px]]  font-normal text-[14px]  text-[#101828]">
                                                                    {record.date}
                                                                </span>
                                                            </div>
                                                        </div>

                                                        {/* Project Emission */}
                                                        <div className="flex flex-row justify-center items-center pr-2.5 w-[205px] h-[48px]">
                                                            <div className="flex flex-row justify-center items-center p-2 gap-1.5 w-[101px] h-8 rounded-lg">
                                                                <span className="w-[81px] h-[18px] font-inter font-normal text-[14px] leading-[18px] text-[#101828]">
                                                                    {record.projectEmission}
                                                                </span>
                                                            </div>
                                                        </div>

                                                        {/* Baseline Emission */}
                                                        <div className="flex flex-row justify-center items-center pr-2.5 w-[241px] h-[48px]">
                                                            <div className="flex flex-row justify-center items-center p-2 gap-1.5 w-[92px] h-8 rounded-lg">
                                                                <span className="w-[72px] h-[18px] font-inter font-normal text-[14px] leading-[18px] text-[#101828]">
                                                                    {record.baselineEmission}
                                                                </span>
                                                            </div>
                                                        </div>

                                                        {/* Energy Consumption */}
                                                        <div className="flex flex-row justify-center items-center pr-2.5 w-[243px] h-[48px]">
                                                            <div className="flex flex-row justify-center items-center p-2 gap-1.5 w-[122px] h-8 rounded-lg">
                                                                <span className="w-[102px] h-[18px] font-inter font-normal text-[14px] leading-[18px] text-[#101828]">
                                                                    {record.energyConsumption}
                                                                </span>
                                                            </div>
                                                        </div>

                                                        {/* Emission Reduction */}
                                                        <div className="flex flex-row justify-center items-center pr-2.5 w-[210px] h-[48px]">
                                                            <div className="flex flex-row justify-center items-center p-2 gap-1.5 w-[101px] h-8 rounded-lg">
                                                                <span className="w-[81px] h-[18px] font-inter font-normal text-[14px] leading-[18px] text-[#101828]">
                                                                    {record.emissionReduction}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        {/* Pagination */}
                                        <div className="flex flex-row justify-end items-center px-6 py-3 w-full h-[62px] border-t border-[#E5E5E5]">
                                            <div className="flex flex-row items-start p-0 gap-4 w-[170px] h-[37px]">
                                                <button 
                                                    onClick={handlePreviousPage}
                                                    disabled={currentPage === 1}
                                                    className={`flex flex-row justify-center items-center p-2 gap-2 w-[90px] h-[37px] border border-[#E5E5E5] rounded-lg transition-colors ${
                                                        currentPage === 1 
                                                            ? 'bg-gray-100 cursor-not-allowed' 
                                                            : 'bg-white hover:bg-gray-50'
                                                    }`}
                                                >
                                                    <span className={`w-[58px] h-[21px] font-inter font-medium text-sm leading-[21px] ${
                                                        currentPage === 1 ? 'text-gray-400' : 'text-[#101828]'
                                                    }`}>
                                                        Previous
                                                    </span>
                                                </button>
                                                <button 
                                                    onClick={handleNextPage}
                                                    disabled={currentPage === totalPages}
                                                    className={`flex flex-row justify-center items-center p-2 gap-2 w-[64px] h-[37px] border border-[#E5E5E5] rounded-lg transition-colors ${
                                                        currentPage === totalPages 
                                                            ? 'bg-gray-100 cursor-not-allowed' 
                                                            : 'bg-white hover:bg-gray-50'
                                                    }`}
                                                >
                                                    <span className={`w-[32px] h-[21px] font-inter font-medium text-sm leading-[21px] ${
                                                        currentPage === totalPages ? 'text-gray-400' : 'text-[#101828]'
                                                    }`}>
                                                        Next
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {/* Comment Modal */}
                {openCommentModal && (
                    <div className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 transition-opacity duration-300 ${
                        isClosing ? 'opacity-0' : 'opacity-100'
                    }`}>
                        <div className={`relative w-[600px] h-[584px] bg-white rounded-2xl transform transition-transform duration-300 ${
                            isClosing ? 'scale-95' : 'scale-100'
                        }`}>
                            
                            {/* Back Button */}
                            <div className="absolute left-6 top-9">
                                <div 
                                    className="flex flex-row items-center gap-0.5 cursor-pointer"
                                    onClick={handleCloseCommentModal}
                                >
                                    {/* Back Arrow Icon */}
                                    <div className="w-6 h-6">
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M5.25 11.25H20.25C20.4489 11.25 20.6397 11.329 20.7803 11.4697C20.921 11.6103 21 11.8011 21 12C21 12.1989 20.921 12.3897 20.7803 12.5303C20.6397 12.671 20.4489 12.75 20.25 12.75H5.25C5.05109 12.75 4.86032 12.671 4.71967 12.5303C4.57902 12.3897 4.5 12.1989 4.5 12C4.5 11.8011 4.57902 11.6103 4.71967 11.4697C4.86032 11.329 5.05109 11.25 5.25 11.25Z"
                                                fill="#000000"
                                            />
                                            <path
                                                d="M5.56086 12L11.7814 18.219C11.9222 18.3598 12.0013 18.5508 12.0013 18.75C12.0013 18.9491 11.9222 19.1401 11.7814 19.281C11.6405 19.4218 11.4495 19.5009 11.2504 19.5009C11.0512 19.5009 10.8602 19.4218 10.7194 19.281L3.96936 12.531C3.89952 12.4613 3.84411 12.3785 3.8063 12.2874C3.76849 12.1963 3.74902 12.0986 3.74902 12C3.74902 11.9013 3.76849 11.8036 3.8063 11.7125C3.84411 11.6214 3.89952 11.5386 3.96936 11.469L10.7194 4.71897C10.8602 4.57814 11.0512 4.49902 11.2504 4.49902C11.4495 4.49902 11.6405 4.57814 11.7814 4.71897C11.9222 4.8598 12.0013 5.05081 12.0013 5.24997C12.0013 5.44913 11.9222 5.64014 11.7814 5.78097L5.56086 12Z"
                                                fill="#000000"
                                            />
                                        </svg>
                                    </div>
                                    {/* Back Text */}
                                    {/* <span className="font-medium text-xs leading-[15px] text-[#2C2C2C]">
                                        Back
                                    </span> */}
                                </div>
                            </div>

                            {/* Title */}
                            <div className="absolute left-1/2 top-8 transform -translate-x-1/2">
                                <h2 className="font-medium text-2xl leading-9 text-[#101828] text-center">
                                    Leave Comment
                                </h2>
                            </div>

                            {/* Content Area */}
                            <div className="absolute left-6 top-[100px] w-[552px] h-[452px] flex flex-col gap-8">
                                
                                {/* Comment Section */}
                                <div className="flex flex-col gap-8 w-full h-[364px]">
                                    <div className="flex flex-col gap-3 w-full h-full">
                                        {/* Comment Label */}
                                        <label className="font-semibold text-[16px] leading-6 text-[#101828]">
                                            Comment
                                        </label>
                                        
                                        {/* Textarea */}
                                        <div className="flex flex-row items-start p-5 gap-2.5 w-full h-[328px] border border-[#667185] border-opacity-50 rounded-lg focus-within:border-[#038B47] focus-within:border-2">
                                            <textarea
                                                value={comment}
                                                onChange={(e) => setComment(e.target.value)}
                                                className="w-full h-full resize-none outline-none font-normal text-[16px] leading-[21px] text-[#101828] placeholder-[#667185]"
                                                placeholder="Enter your comment here..."
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Submit Button */}
                                <button 
                                    className={`flex flex-row justify-center items-center py-2 px-4 gap-3 w-full h-14 rounded-lg ${
                                        comment.trim() 
                                            ? 'bg-gradient-to-r from-[#038B47] to-[#00AED9] cursor-pointer hover:opacity-90'
                                            : 'bg-gray-300 cursor-not-allowed'
                                    }`}
                                    onClick={handleCommentSubmit}
                                    disabled={!comment.trim()}
                                >
                                    <span className="font-semibold text-base leading-6 text-white">
                                        Submit Comment
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Verification Confirmation Modal */}
                {openVerifyModal && (
                    <div className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 transition-opacity duration-300 ${
                        isClosing ? 'opacity-0' : 'opacity-100'
                    }`}>
                        <div className={`relative w-[600px] h-[338px] bg-white rounded-2xl transform transition-transform duration-300 ${
                            isClosing ? 'scale-95' : 'scale-100'
                        }`}>
                            
                            {/* Close Button */}
                            <div className="absolute right-6 top-6">
                                <button 
                                    onClick={handleCloseVerifyModal}
                                    className="w-6 h-6 cursor-pointer hover:bg-gray-100 rounded transition-colors flex items-center justify-center"
                                    disabled={verificationLoading}
                                >
                                    <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M18.3 5.70997C18.1136 5.52261 17.8599 5.41742 17.595 5.41742C17.3301 5.41742 17.0764 5.52261 16.89 5.70997L12 10.59L7.11 5.69997C6.92361 5.51261 6.66993 5.40742 6.405 5.40742C6.14007 5.40742 5.88639 5.51261 5.7 5.69997C5.31 6.08997 5.31 6.71997 5.7 7.10997L10.59 12L5.7 16.89C5.31 17.28 5.31 17.91 5.7 18.3C6.09 18.69 6.72 18.69 7.11 18.3L12 13.41L16.89 18.3C17.28 18.69 17.91 18.69 18.3 18.3C18.69 17.91 18.69 17.28 18.3 16.89L13.41 12L18.3 7.10997C18.68 6.72997 18.68 6.08997 18.3 5.70997Z"
                                            fill="#667185"
                                        />
                                        
                                    </svg>
                                </button>
                            </div>

                            {/* Content Area */}
                            <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[450px] h-[212px] flex flex-col items-center gap-8">
                                
                                {/* Text Content */}
                                <div className="flex flex-col items-center gap-4 w-[428px] h-[124px]">
                                    {/* Title */}
                                    <h2 className="font-semibold text-2xl leading-9 text-[#101828] text-center">
                                        Confirm Verification
                                    </h2>
                                    
                                    {/* Description */}
                                    <p className="font-normal text-[16px] leading-6 text-[#667185] text-center w-full">
                                        By proceeding, you affirm that all data and information meet the required standard, and all procedures are standard throughout the process.
                                    </p>
                                </div>

                                {/* Buttons */}
                                <div className="flex flex-row items-start gap-6 w-full h-14">
                                    {/* Cancel Button */}
                                    <button 
                                        className="flex flex-row justify-center items-center py-2 px-4 gap-2 w-[199px] h-14 border border-[#667185] rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                        onClick={handleCloseVerifyModal}
                                        disabled={verificationLoading}
                                    >
                                        <span className="font-semibold text-base leading-6 text-[#667185]">
                                            Cancel
                                        </span>
                                    </button>

                                    {/* Confirm Button */}
                                    <button 
                                        className="flex flex-row justify-center items-center py-2 px-4 gap-2 w-[227px] h-14 bg-gradient-to-r from-[#038B47] to-[#00AED9] rounded-lg hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
                                        onClick={handleVerifyConfirm}
                                        disabled={verificationLoading}
                                    >
                                        {verificationLoading ? (
                                            <div className="flex items-center gap-2">
                                                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                                <span className="font-semibold text-base leading-6 text-white">
                                                    Verifying...
                                                </span>
                                            </div>
                                        ) : (
                                            <span className="font-semibold text-base leading-6 text-white">
                                                Confirm Verification
                                            </span>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default NonGreenWeb3Data;